import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SendBulkEmailService } from './send-bulk-email.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-send-bulk-email',
  templateUrl: './send-bulk-email.component.html'
})

export class SendBulkEmailComponent implements OnInit {
  isForMatAccounts: boolean = true;
  emailIds: string[] = [];
  sendEmailForm: FormGroup;
  allSelected = true;

  constructor(@Optional() public ref: MatDialogRef<SendBulkEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sendBulkEmailService: SendBulkEmailService,
    private toasterService: ToastrService,
    private fb: FormBuilder) {
    this.sendEmailForm = this.fb.group({
      selectedEmailIds: new FormControl([], Validators.required),
      content: new FormControl('', Validators.required)
    });
  }

  ngOnInit(): void {
    this.isForMatAccounts = this.data.isForMatAccounts;
    if (this.isForMatAccounts) {
      let sectorId = Number(sessionStorage.getItem('sector'));
      this.sendBulkEmailService.getAllMatAdminMailIds(sectorId).subscribe({
        next: (response: any) => {
          this.emailIds = response;
          this.sendEmailForm.get('selectedEmailIds')?.setValue(this.emailIds);
        },
        error: (error: HttpErrorResponse) => {
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        }
      });
    }
    else {
      this.sendBulkEmailService.getAllSchoolAdminMailIds().subscribe({
        next: (response: any) => {
          this.emailIds = response;
          this.sendEmailForm.get('selectedEmailIds')?.setValue(this.emailIds);
        },
        error: (error: HttpErrorResponse) => {
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        }
      });
    }
  }

  toggleSelectAll() {
    this.allSelected = !this.allSelected;
    if (this.allSelected) {
      this.sendEmailForm.controls['selectedEmailIds'].setValue(this.emailIds);
    } else {
      this.sendEmailForm.controls['selectedEmailIds'].setValue([]);
    }
  }

  isAllSelected() {
    const selectedItems = this.sendEmailForm.controls['selectedEmailIds'].value || [];
    if(selectedItems.length == this.emailIds.length){
      this.allSelected = true;
    }
    else{
      this.allSelected = false;
    }
    return this.allSelected;
  }

  close() {
    this.ref.close();
  }

  onSend() {
    if (this.sendEmailForm.valid) {
      const { selectedEmailIds, content } = this.sendEmailForm.value;
      this.sendBulkEmailService.sendBulkEmail(selectedEmailIds, content).subscribe({
        next: (isSuccess: boolean) => {
          if (isSuccess) {
            this.toasterService.success('Emails sent successfully!');
            this.ref.close();
          }
          else {
            this.toasterService.error('Error in Sending Mail', 'Error');
          }
        },
        error: (error: HttpErrorResponse) => {
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        }
      });
    }
  }

  get isSendButtonDisabled(): boolean {
    return !this.sendEmailForm.valid;
  }

}
